import { Button, Spinner } from 'avo-ui'
import { useNavigate } from 'react-router-dom'
import icAddSquare from 'assets/images/ic-add-square-white.svg'
import icEditYellow from 'assets/images/ic-edit-yellow.svg'
import icTrash from 'assets/images/ic-trash.svg'
import ModalDelete from 'components/commons/modal-delete'

export const UserRole = ({ dataList, showModalDelete, setShowModalDeleteHandler, onDelete, isLoading, isDeleting }) => {
    const navigate = useNavigate()

    return (
        <div className={'flex flex-col gap-y-5 px-9 py-4'}>
            <div className={'flex justify-between items-center bg-blue-5 px-10 py-4 rounded-lg'}>
                <p className={'text-lg text-primary-100 font-bold'}>User Role</p>
                <Button
                    icon={icAddSquare}
                    title={'Create User Role'}
                    onClick={() => navigate('/user/user-role/create-role')}
                />
            </div>
            <div className={'flex flex-col space-y-3'}>
                {isLoading ? (
                    <Spinner className={'w-8 h-8 my-7 mx-auto !border-blue-50'} />
                ) : (
                    dataList?.map((item, index) => (
                        <div
                            key={index}
                            className={
                                'flex justify-between items-center px-10 py-4 rounded-lg border border-neutral-20 text-base'
                            }
                        >
                            <div className={'capitalize text-primary-100 font-bold'}>{item?.name}</div>
                            <div className={'text-neutral-80 font-semibold'}>{item?.user_count} Users</div>
                            <div className={'text-neutral-80 font-semibold'}>{item?.permission_count} Access</div>
                            <div className={'flex space-x-3 justify-center'}>
                                <Button
                                    type={'outline'}
                                    title={'Edit'}
                                    icon={icEditYellow}
                                    onClick={() => navigate(`/user/user-role/update-role?roleId=${item?.id}`)}
                                />
                                <Button
                                    type={'outline'}
                                    title={'Delete'}
                                    icon={icTrash}
                                    disabled={item?.user_count}
                                    onClick={() => setShowModalDeleteHandler(item?.id, true)}
                                />
                            </div>
                        </div>
                    ))
                )}
            </div>
            {showModalDelete && (
                <ModalDelete
                    show={showModalDelete}
                    onHide={() => setShowModalDeleteHandler(null, false)}
                    description={'Are You Sure to Delete Role?'}
                    isLoading={isDeleting}
                    onDelete={onDelete}
                />
            )}
        </div>
    )
}
